import React, { createContext, useContext } from 'react';
import { useSidebar } from '../hooks/useSidebar';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const sidebarData = useSidebar();

  const collapseSidebar = () => {
    if (!sidebarData.isCollapsed) {
      sidebarData.toggleCollapsed();
    }
  };

  const expandSidebar = () => {
    if (sidebarData.isCollapsed) {
      sidebarData.toggleCollapsed();
    }
  };

  return (
    <SidebarContext.Provider value={{
      ...sidebarData,
      collapseSidebar,
      expandSidebar
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarProvider');
  }
  return context;
};